"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uninstallModalReducer;

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

function uninstallModalReducer(uninstallModal, action) {
  switch (action.type) {
    case _ActionTypes.default.SHOW_UNINSTALL_MODAL:
      return uninstallModal.merge({
        modalType: action.payload.modalType,
        goodName: action.payload.goodName,
        goodSubtype: action.payload.goodSubtype,
        open: true,
        assetsWhereGoodInUse: action.payload.assetsWhereGoodInUse,
        packChildrenInUse: action.payload.packChildrenInUse
      });

    case _ActionTypes.default.DISMISSED_UNINSTALL_MODAL:
      return uninstallModal.merge({
        modalType: '',
        goodName: '',
        goodSubtype: '',
        open: false,
        assetsWhereGoodInUse: [],
        packChildrenInUse: []
      });

    default:
      return uninstallModal;
  }
}

module.exports = exports.default;